import { FaireProductParams } from "../../models/types/faire.types";
import { authAxios } from "../default";

export const faireApi = {
  /*
  |--------------------------------------------------------------------------
  | Fetches all the Faire Products Based on provided parameters
  |--------------------------------------------------------------------------
  |
  */
  fetchProducts: async (params: FaireProductParams): Promise<any> => {
    return authAxios.get("/api/products/faire", {
      params: params,
    });
  },

  /*
  |--------------------------------------------------------------------------
  | Fetches Product Count Based on their Statuses
  |--------------------------------------------------------------------------
  |
  */
  fetchProductsCount: async (): Promise<any> => {
    return authAxios.get("/api/products/faire/count");
  },

  /*
  |--------------------------------------------------------------------------
  | Fetches Orders Count from Faire 
  |--------------------------------------------------------------------------
  |
  */
  fetchFaireOrdersCount: async (): Promise<any> => {
    return authAxios.get("/api/orders/count");
  },

  /*
  |--------------------------------------------------------------------------
  | Fetch all the Taxonomies or Categories from Faire 
  |--------------------------------------------------------------------------
  |
  */
  fetchFaireCategories: async (params: any): Promise<any> => {
    return authAxios.get("/api/taxonomies/faire", {
      params: params,
    });
  },

  /*
  |--------------------------------------------------------------------------
  | Import products from Faire to our store
  |--------------------------------------------------------------------------
  |
  */
  importProducts: async (data?: any): Promise<any> => {
    return authAxios.post("/api/products/faire/import", data);
  },

  /*
  |--------------------------------------------------------------------------
  | Upload products from Faire to Wix store
  |--------------------------------------------------------------------------
  |
  */
  uploadToWix: async (productIds?: any): Promise<any> => {
    return authAxios.post("/api/products/faire/export", {
      export: productIds,
    });
  },

  /*
  |--------------------------------------------------------------------------
  | Bulk Upload products from Faire to Wix store
  |--------------------------------------------------------------------------
  |
  */
  bulkUploadToWix: async (productIds?: any): Promise<any> => {
    return authAxios.post("/api/products/faire/export/bulk", {
      export: productIds,
    });
  },

  /*
  |--------------------------------------------------------------------------
  | Retrieve faire Store Details
  |--------------------------------------------------------------------------
  |
  */
  fetchStoreDetail: async (): Promise<any> => {
    return authAxios.get("/api/dashboard/faire/detail");
  },
};
